import React, { useState } from "react";
import "./ProjectModal.css";



export default function ProjectModal({ project, onClose }) {
  const [index, setIndex] = useState(0);

  const next = () =>
    setIndex((i) => (i + 1) % project.images.length);

  const prev = () =>
    setIndex((i) =>
      i === 0 ? project.images.length - 1 : i - 1
    );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="modal-image">
          <img
            src={project.images[index]}
            alt={project.title}
          />

          {project.images.length > 1 && (
            <>
              <button className="nav left" onClick={prev}>‹</button>
              <button className="nav right" onClick={next}>›</button>
            </>
          )}
        </div>

        <div className="modal-content">
          <h2>{project.title}</h2>

          <div className="services">
            {project.services.map((s, i) => (
              <div key={i} className="service-item">
                {s}
              </div>
            ))}
          </div>

          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>

      </div>
    </div>
  );
}
